<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="grid-view">
    <div v-show="currentOptStatus===optStatusDefs.normal" class="main-content tab-billing">
      <query-billing
        key="queryBilling"
        ref="queryBilling"
        identify="tabBillingSearchItem"
        view-source="tabBilling"
        config-module="50401"
        grid-config-module="19070301"
        billing-clearing-state-param="BillingClearingState"
        billing-job-state-param="BillingJobState"
        billing-state-param="BillingState"
        :default-option-values="searchConditions.billingDefaultOptions"
        :is-ar="searchConditions.paymentType"
        :oversea="searchConditions.chargeTypeGroup"
        :show-invoice-state="true"
        :show-controlled-charge="true"
        :show-invoice-no="true"
        :show-fba="false"
        :show-wht="true"
        :has-check-role="true"
        :is-append-query="true"
        :input-date-start="searchConditions.inputDateStart"
        :input-date-end="searchConditions.inputDateEnd"
        :internal-charge="searchConditions.internalCharge"
        type="both"
        total-type="auto"
        @rowDoubleClicked="rowDoubleClicked"
        @onRowClicked="onBillingGridItemClick"
      >
        <div slot="operations">
          <el-button v-permission="['button_ACTBilling_createGroupFromBillings']" no="1" type="primary" @click="createBillingGroupClick">{{ $t('CargoMsg.Cargo_NewAccountStatement') }}</el-button>
          <el-button v-permission="['button_ACTBilling_editBilling']" no="2" type="primary" @click="showBillDetailView(undefined,true,false)">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-permission="['button_ACTBilling_deleteBilling']" no="3" type="danger" @click="deleteBilling">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <el-button v-permission="['button_ACTBilling_viewBilling']" no="4" type="primary" @click="showBillDetailView(undefined,true,true)">{{ $t('CargoMsg.Cargo_View') }}</el-button>
          <el-button v-permission="['button_ACTBilling_confirmBilling']" no="5" type="primary" @click="confirmBilling">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
          <el-button v-permission="['button_ACTBilling_unconfirmBilling']" no="6" type="primary" @click="unConfirmBilling">{{ $t('CargoMsg.Cargo_CancelConfirm') }}</el-button>
          <el-tooltip type="primary" :content="$t('Billing.billing_recheckTip')" placement="bottom">
            <div class="btn" style="display: inline-block; margin-right: 5px;">
              <el-button v-permission="['button_ACTBilling_recheckBilling']" no="7" style="margin-left: 5px;" type="primary" @click="recheckBilling">{{ this.$t('Billing.billing_recheck') }}</el-button>
            </div>
          </el-tooltip>
          <!--取消复核-->
          <el-button v-permission="['button_ACTBilling_cancelRecheckBilling']" no="8" type="primary" @click="cancelRecheckBilling">{{ this.$t('Billing.billing_cancelRecheck') }}</el-button>
          <!-- <el-button v-permission="['button_ACTBilling_printBilling']" no="9" type="primary" @click="printBilling">{{ $t('CargoMsg.Cargo_Print') }}</el-button> -->
          <el-dropdown
            v-permission="['button_ACTBilling_printBilling']"
            no="9"
            split-button
            type="primary"
            style="margin: 0 5px;"
            @click="printBilling($t('CargoMsg.Cargo_Print'))"
            @command="printBilling"
          >
            {{ $t('CargoMsg.Cargo_Print') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('Clearing.PrintByAccountNumber')">{{ $t('Clearing.PrintByAccountNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-if="role.createInvoiceFromBilling || role.createInvoiceApFromBilling" no="10" type="primary" @click="makeInvoiceEvent">{{ $t('CargoMsg.Cargo_Invoicing') }}/{{ $t('CargoMsg.Cargo_CollectInvoice') }}</el-button>
          <el-button v-permission="['button_ACTBilling_writeoffBilling']" no="11" type="primary" @click="writeoffHandler">{{ $t('CargoMsg.Cargo_WriteOff') }}</el-button>
          <el-button v-permission="['button_ACTBilling_payauthFromCharges']" no="12" type="primary" @click="doBillPayment"> {{ $t('CargoMsg.Cargo_ApplyForPayment') }} </el-button>
          <el-button v-show="permissionBtnInvalid" no="13" type="primary" @click="onInvalidClickEvent()">{{ $t('FinanceManage.international_invalid') }}</el-button>
          <el-button no="14" type="primary" @click="signEvent">{{ $t('CargoMsg.Cargo_Mark') }}</el-button>
          <el-button no="15" type="primary" @click="cancelSignEvent">{{ $t('CargoMsg.Cargo_CancelMark') }}</el-button>
          <el-button v-show="searchConditions.chargeTypeGroup === 1 && $checkPermission(['button_billTab_forceDelete'])" no="16" type="danger" @click="forceDeleteHandler()">{{ $t('CargoMsg.Cargo_ForceDelete') }}</el-button>
          <!-- <el-button type="primary" @click="toAutomaticReconciliation">{{ $t('CargoMsg.AutomaticReconciliation') }}</el-button> -->
          <el-button v-if="toExoSystemOC" no="17" type="primary" @click="prePaymentHandler">{{ $t('CargoMsg.Cargo_OcPrePayment') }}</el-button>
          <el-button v-if="toExoSystemOC" no="18" type="primary" @click="cancelPrePaymentHandler">{{ $t('CargoMsg.Cargo_OcCancelPrePayment') }}</el-button>
          <el-button v-if="role.batchUpload" type="primary" no="batchUpload" @click="batchUploadFileHandler">{{ $t('CargoMsg.Cargo_BatchUploadFile') }}</el-button>
          <!--导出Accpac海外账单数据-->
          <el-button v-show="toExoSystemTp && searchConditions.chargeTypeGroup === 1 && $checkPermission(['button_ACTBilling_exportPillBilling'])" no="exportPillBilling" type="primary" @click="exportPillBillingHandler">{{ $t('PillReport.ExportBillingData') }}</el-button>
          <el-button v-if="qlToFinanceApi && $checkPermission(['button_ACTBilling_syncCloud'])" type="primary" no="25" @click="syncCloudPlatformFunc">{{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}</el-button>
          <el-button v-show="searchConditions.chargeTypeGroup === 1 && $checkPermission(['button_ACTBilling_redPunchBilling'])" no="redPunchBilling" type="danger" @click="redPunchBillingHandler">{{ $t('CargoMsg.Cargo_WriteBack') }}</el-button>
          <el-button v-if="$checkPermission(['button_ACTBilling_billingInvoicePool']) && searchConditions.paymentType === 0" type="primary" no="showInvoicePoolDialog" @click="showInvoicePoolDialog">{{ $t('CargoMsg.Cargo_InvoicePoolReceiving') }}</el-button>
          <template v-for="(item, index) in instructioinBtns">
            <el-button
              :key="'instruction' + index"
              type="primary"
              :disabled="!item.allowOperate"
              @click="onInstructionClick(item)"
            >
              {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
            </el-button>
          </template>
        </div>
        <template v-slot:searchAreaHeader>
          <div class="app-main-inner-row extension-conditions-form">
            <el-form ref="basicForm" inline label-position="left">
              <el-form-item v-permission="['filter_ACTBilling_allBillings','filter_ACTBilling_arBillings','filter_ACTBilling_apBillings']" :label="$t('CargoMsg.Cargo_PaymentReceiveMethodP')">
                <el-radio-group v-model="searchConditions.paymentType" no="19">
                  <el-radio v-permission="['filter_ACTBilling_arBillings']" :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                  <el-radio v-permission="['filter_ACTBilling_apBillings']" :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                  <el-radio v-permission="['filter_ACTBilling_allBillings']" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-permission="['filter_ACTBilling_allRegionalBillings','filter_ACTBilling_overseaBillings','filter_ACTBilling_localBillings']" :label="$t('CargoMsg.Cargo_BillOfType')">
                <el-radio-group v-model="searchConditions.chargeTypeGroup" no="20" @change="showInvalid">
                  <el-radio v-if="showDomestic" :label="0">{{ $t('CargoMsg.Cargo_Domestic') }}</el-radio>
                  <el-radio v-if="showInternational" :label="1">{{ $t('CargoMsg.Cargo_International') }}</el-radio>
                  <el-radio v-if="showAllRegionalBillings" v-permission="['filter_ACTBilling_allRegionalBillings']" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                  <el-radio v-if="showAgentBilling" :label="2">{{ $t('CargoMsg.Cargo_AgentBilling') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ReconciliationTypeP')">
                <el-radio-group v-model="billType" no="21">
                  <el-radio label="job">{{ $t('CargoMsg.Cargo_ByJob') }}</el-radio>
                  <el-radio label="charge">{{ $t('CargoMsg.Cargo_ByFee') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="useOrderCenterMode" label-width="0">
                <el-checkbox v-model="searchConditions.internalCharge" no="22">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_BillDateP')">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateStart"
                        no="23"
                        type="date"
                        style="width:100%;"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      /></el-form-item>
                  </el-col>
                  <el-col :span="1"><span style="font-size: 12px;">{{ $t('CargoMsg.Cargo_To') }}</span></el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateEnd"
                        no="24"
                        type="date"
                        style="width:100%;"
                        clearable
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" style="padding-left: 5px">
                    <el-form-item label-width="0">
                      <el-checkbox v-model="allowTwoYearOutside" no="25">{{ $t('Billing.billingJob_lockCheckBoxDate') }}</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </query-billing>
    </div>
    <!--账单详情-->
    <bill-detail
      v-if="currentOptStatus===optStatusDefs.billDetailView"
      :billing-uuid="billingUuid"
      :view-billing="viewBilling"
      :r-type="billType"
      :location="location"
      view-source="bill"
      @cancel="backBillingList"
      @backBillingList="backBillingList"
    />
    <!--创建对账单详情-->
    <bill-group-detail
      v-if="currentOptStatus===optStatusDefs.billGroupDetailView"
      view-source="bill"
      :new-billing-group="billingGroupProperties.billingGroup"
      :new-billings="billingGroupProperties.billings"
      :view-billing-group="false"
      :location="location"
      @cancel="currentOptStatus=optStatusDefs.normal"
      @backBillingList="backBillingList"
    />
    <!--销账-->
    <write-off-dialog
      v-if="writeOffDialog.visible"
      ref="dgWriteoff"
      :visible.sync="writeOffDialog.visible"
      :title="title"
      :properties="properties"
      :location="location"
      @writeoffSuccessHandler="reloadData"
    />
    <!--申请付款-->
    <bill-payment-dialog
      ref="billPayment"
      :open-sap-config="false"
      :visible.sync="showBillPaymentDialog"
      :create-submit="true"
      :location="location"
      step="step2"
      mode="overview"
      @cancel="cancelBillPayment"
    />
    <!--开票-->
    <make-invoice-dialog
      ref="invoice"
      view-source="bill"
      :location="location"
      @reloadData="reloadData"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="cargoTemplateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
    />
    <!-- 付款申请-H5（客户化版本）-->
    <new-bill-payment-dialog
      :visible="billPaymentDialogForH5.visible"
      :title="billPaymentDialogForH5.title"
      :bill-payment-account-id="billPaymentDialogForH5.defaultConditions.accountId"
      :view-source="billPaymentDialogForH5.source"
      :bill-payment-uuid="billPaymentDialogForH5.uuid"
      :default-conditions="billPaymentDialogForH5.defaultConditions"
      @close="billPaymentDialogForH5.visible=false"
    />
    <!--付款申请-H5（详情)-->
    <bill-payment-detail-for-h5
      v-if="billPaymentDialogForH5.billPaymentDetailProperties.visible"
      ref="billPaymentDetailForH5"
      :bill-payment-uuid="billPaymentDialogForH5.billPaymentDetailProperties.uuid"
      :title="billPaymentDialogForH5.billPaymentDetailProperties.title"
      :visible.sync="billPaymentDialogForH5.billPaymentDetailProperties.visible"
      :state="billPaymentDialogForH5.billPaymentDetailProperties.state"
      :charges="billPaymentDialogForH5.billPaymentDetailProperties.charges"
      :charges-dirty="true"
      :bill-payment-dirty="true"
      :open-sap-config="false"
      :input-by="billPaymentDialogForH5.billPaymentDetailProperties.inputBy"
      :parent-context="context"
      :location="location"
      view-source="tabBilling"
      @toPreStep="toPreStep"
      @refreshBillPayment="refreshBillPaymentH5"
    />

    <!--标记账单弹出窗-->
    <sign-billing-dialog
      :visible.sync="signBillingDialog.visible"
      :billing-keys="signBillingDialog.billingKeys"
      @signBillingCallBack="signBillingCallBack"
    />

    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />

    <!-- 云文件上传对话框 -->
    <batch-upload-file
      :visible.sync="cloudFile.visible"
      :redis-key="cloudFile.redisKey"
      :job-num="cloudFile.num"
      page-source="tabBilling"
      :lob="cloudFile.lob"
    />

    <!-- 发票池弹窗 -->
    <invoice-pool-dialog
      v-if="invoicePoolDialog.visible"
      :visible.sync="invoicePoolDialog.visible"
      :seller-tax-name-default-value="invoicePoolDialog.sellerTaxNameDefaultValue"
      :selected-entities="invoicePoolDialog.selectedEntities"
      :make-invoice-method="invoicePoolDialog.makeInvoiceMethod"
      :operation="invoicePoolDialog.operation"
      :source="invoicePoolDialog.source"
    />

  </div>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import billDetail from './billDetail'
import billGroupDetail from './billGroupDetail'
import writeOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import BillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import {
  batchDelBilling,
  batchConfirmBilling,
  setBillingsNo,
  invalidBilling,
  cancelSignBilling,
  forceDeleteBilling,
  validateForceDeleteBilling,
  prePayment,
  cancelPrePayment, recheckBilling, cancelRecheckBilling, getChargeByBillingKeys, syncCloudPlatformQL,
  redPunchBilling,
  validateRedPunchBilling, batchUnConfirmBilling
} from '@/api/clearing/billingNative'
import URL from '@/api/urlTranslator'
import { cacheName, cache } from '@/utils/cacheManager'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'
import { getBankAccountList } from '@/api/bankAccount'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import TabBillingHp from './tabBillingHP'
import moment from 'moment'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { BookingNewContext } from '@/views/cargo/v0/SeaImport/bookingNewContext'
import QueryBilling from '@/views/cargo/v0/Clearing/components/query/queryBilling'
import newBillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/newBillPayMentDialog'
import billPaymentDetailForH5 from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/billPaymentDetail'
import { BillingGroup } from '@/class/model/act/BillingGroup'
import signBillingDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/signBillingDialog'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { BPM_STATES_UN_APPROVED, LOG_RECONCILIATION } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import { getJobByKeys } from '@/api/booking/job'
import ColumnUtils from '@/utils/ColumnUtils'
import { exportBilling, exportBillingCL } from '@/api/clearing/pillReport'
import { queryJobByChargeKeysFunc } from '@/api/clearing/charge'
import batchUploadFile from '@/components/Cargo/Common/batchUploadFile.vue'
import { checkConfirmBilling } from '@/api/clearing/invoice'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import invoicePoolDialog from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolDialog.vue'
import UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { getInstructions, instructionPushInfo } from '@/api/sysManage/uiCustom'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Job } from '@/class/model/booking/Job'
import { wkVerifyRollbackPush } from '@/api/clearing/financeManage'

export default {
  name: 'TabBilling',
  components: {
    invoicePoolDialog,
    batchUploadFile,
    billDetail,
    searchItem,
    billGroupDetail,
    writeOffDialog,
    BillPaymentDialog,
    makeInvoiceDialog,
    cargoTemplateSelectorDialog,
    ChargeCurrencyTotalGroup,
    QueryBilling,
    newBillPaymentDialog, // 付款申请-H5（客户化版本）
    billPaymentDetailForH5, // 付款申请-H5（客户化版本）-详情
    signBillingDialog,
    BatchCheckingWindow
  },
  data() {
    return {
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      allowTwoYearOutside: false,
      showWriteOffDialog: false,
      showBillPaymentDialog: false,
      permissionBtnInvalid: false,
      selectedBilling: null, // 选中数据
      departmentTeamUser: null, // 同部门的人
      context: BookingNewContext.getInstance(),
      documentManage: new DocumentManage(),
      optStatusDefs: {
        billDetailView: 'billDetailView', // 账单详情页
        billGroupDetailView: 'billGroupDetailView', // 对账单详情页
        normal: 'normal'// 初始状态-无操作
      },
      currentOptStatus: 'normal',
      billType: 'job',
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      searchConditions: {
        snapshotConditionsBilling: [], // 结算模块-开票/收票-按账单查询时使用此变量
        paymentType: 1, // 应收/应付
        advance: -1, //  是否垫付
        isNeedInvoice: -1, // 是否需要开票
        hasInvoice: -1, // 是否开票
        billingGroupStates: [], // 对账单状态
        selectedEntitiesForHedging: [],
        chargeTypeGroup: 0, // 账单类型（国内/国外）
        exceptKeys: [], // 在查询中想要例外的对象列表
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'),
        inputDateEnd: '',
        billingClearingState: -1, // 核销状态（0:有未销账,1:有已销账）
        billingJobStates: [], // 账单-业务状态
        billingStates: [], // 账单-业务状态
        billingClearingStates: [], // 账单-核销状态
        billingStateParam: 'BillingState',
        billingClearingStateParam: 'BillingClearingState',
        billingJobStateParam: 'BillingJobState',
        billingRequires: ['writeoff', 'invoice', 'invoiceNo'],
        billingDefaultOptions: [],
        internalCharge: false // 内结
      },
      billingUuid: '',
      viewBilling: true,
      billingGroupProperties: {
        billingGroup: {}, // 新的对账单实体
        billings: [] // 对账单详情-账单列表数据源
      },
      billingGroup: new BillingGroup().fillDefaultValue().getData(),
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 3 // 开票方式:3代表账单
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'BILLINGLIST',
        data: {
          BILLING_LIST_UUID: []
        }
      },
      prePrintCallback: null,
      showLoading: true, // 是否显示加载中样式
      viewSource: 'tabBilling', //  页面请求发起方
      tabBillingHp: new TabBillingHp(this),
      showColumnsVisible: { // 控制显示列是否隐藏（结算模块-开票/收票-按账单查询时使用此变量）
        showVoucherDate: true, // 发票号
        showInvoiceState: false,
        showRealClearingState: false,
        showVerifiedAmount: false,
        showUnInvoiceAmount: true
      },
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: false, // 是否海外销账
        defaultCurrency: 'RMB', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: 0, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: false, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [], // 费用所包含的币种
        otherCurrencyRate: [] // 其它币种和汇率
      },
      writeOffDialog: { visible: false },
      paymentApplicationSendingCloudPlatform: false, // 是否开启申请付款发送云平台功能
      billPaymentDialogForH5: { // 付款申请-H5 弹窗变量
        visible: false,
        title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees'),
        source: 'tabBilling',
        uuid: '',
        defaultConditions: {
          exceptKeys: [],
          hasBillPayment: -1,
          hasBilling: -1,
          oversea: -1,
          accountId: 0,
          billingKeys: [] // 账单UUID
        },
        billPaymentDetailProperties: {
          visible: false,
          title: '',
          uuid: '',
          state: -1,
          charges: [],
          chargesDirty: false,
          billPaymentDirty: false,
          inputBy: 0
        }
      },
      signBillingDialog: { // 标记账单
        billingKeys: [],
        visible: false
      },
      billingTypeConfig: '0,1', // 账单类型可选项,默认值0，1
      billingGroupCreateBillingStatusRequirement: '12,13', // 新增对账单状态,默认值12已复核,13未复核
      toExoSystemOC: false, // 是否橙联推送
      location: LOG_RECONCILIATION.code,
      role: {
        createInvoiceFromBilling: false,
        createInvoiceApFromBilling: false,
        batchUpload: false
      },
      uploadSource: 'tabReconciliation',
      cloudFile: {
        visible: false,
        lob: 'SE',
        num: 0,
        redisKey: ''
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: [],
        lob: ''
      },
      invoicePoolDialog: {
        visible: false,
        sellerTaxNameDefaultValue: '',
        selectedEntities: [],
        operation: '',
        source: 'billing',
        makeInvoiceMethod: 3
      },
      instructioinBtns: [],
      customInstructionUuid: '',
      btnConfimKeys: [],
      btnRecheckBillings: [],
      toExoSystemTp: false, // 是否太平
      overseasBillVarifyBillStatus: -2, // 海外账单核销状态
      qlToFinanceApi: false
    }
  },
  computed: {
    url() {
      return URL
    },
    dynamicColumnDefs() {
      return this.tabBillingHp.dynamicColumnDefs()
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    },
    queryOfficeId() {
      return this.$refs.queryBilling.queryOfficeId
    },
    showDomestic() { // 国内账单
      return this.billingTypeConfig.indexOf('0') > -1 && this.$checkPermission(['filter_ACTBilling_localBillings'])
    },
    showInternational() { // 国外账单
      return this.billingTypeConfig.indexOf('1') > -1 && this.$checkPermission(['filter_ACTBilling_overseaBillings'])
    },
    showAllRegionalBillings() { // 全部区域账单
      return (this.billingTypeConfig.indexOf('0') > -1 || this.billingTypeConfig.indexOf('1') > -1) && this.$checkPermission(['filter_ACTBilling_allRegionalBillings'])
    },
    showAgentBilling() { // 代理分成账单
      return this.billingTypeConfig.indexOf('2') > -1
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
    billType(newVal) {
    },
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Invoice.invoice_unlockBusinessDateQuery'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    currentOptStatus(newVal) {
      if (newVal === this.optStatusDefs.normal) {
        console.log('dolayout', document.querySelector('.ag-header-container'))
        document.querySelector('.ag-header-container').style.left = 0 + 'px'
        console.log('dolayout', document.querySelector('.ag-header-container'))
      }
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        this.qlToFinanceApi = cache.config.get('ToFinanceApi') === 'QL' // 青旅202507
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.tabBillingHp.changeCustomSearchItems()
    this.permissionBtnInvalid = this.$checkPermission(['button_ACTBilling_toVoidButton']) && (this.searchConditions.chargeTypeGroup === 0 || this.searchConditions.chargeTypeGroup === 1)
    this.paymentApplicationSendingCloudPlatform = Number(cache.config.get('PaymentApplicationSendingCloudPlatform')) === 1
    this.billingGroupCreateBillingStatusRequirement = String(cache.config.get('BillingGroupCreateBillingStatusRequirement'))
    this.billingTypeConfig = String(cache.config.get('billingType'))
    this.toExoSystemOC = Number(cache.config.get('ToExoSystem')) === 2
    this.toExoSystemTp = String(cache.config.get('ToExoSystem')) === 'TP'
    this.overseasBillVarifyBillStatus = String(cache.config.get('OverseasBillVarifyBillStatus'))
    this.role.createInvoiceFromBilling = this.$checkPermission(['button_ACTBilling_createInvoiceFromBilling']) // 开票权限
    this.role.createInvoiceApFromBilling = this.$checkPermission(['button_ACTBilling_createInvoiceApFromBilling']) // 收票权限
    this.role.batchUpload = this.$checkPermission(['button_ACTBilling_billingBatchUpload']) // 批量上传按钮
    // 收付方式初始化
    if (this.$checkPermission(['filter_ACTBilling_arBillings'])) { // 应收
      this.searchConditions.paymentType = 1
    } else if (this.$checkPermission(['filter_ACTBilling_apBillings'])) { // 应付
      this.searchConditions.paymentType = 0
    } else { // 全部
      this.searchConditions.paymentType = -1
    }
    // 账单类型初始化
    if (this.billingTypeConfig.indexOf('0') > -1 && this.$checkPermission(['filter_ACTBilling_localBillings'])) { // 国内
      this.searchConditions.chargeTypeGroup = 0
    } else if (this.billingTypeConfig.indexOf('1') > -1 && this.$checkPermission(['filter_ACTBilling_overseaBillings'])) { // 国外
      this.searchConditions.chargeTypeGroup = 1
    } else if ((this.billingTypeConfig.indexOf('0') > -1 || this.billingTypeConfig.indexOf('1') > -1) && this.$checkPermission(['filter_ACTBilling_allRegionalBillings'])) { // 全部
      this.searchConditions.chargeTypeGroup = -1
    } else if (this.billingTypeConfig.indexOf('2') > -1) { // 代理分成
      this.searchConditions.chargeTypeGroup = 2
    }
    await this.loadInstructionButtons()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 跳转自动对账
    // toAutomaticReconciliation() {
    //   this.$router.push({ name: 'AutomaticReconciliation' })
    // },
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y')
        return currDate < beforeTwoYear
      }
      return false
    },
    // 展示账单详情
    showBillDetailView(billing, needChecked, isView = true) {
      const self = this
      self.viewBilling = isView
      if (needChecked) {
        const billing = this.$refs.queryBilling.selectedItem
        if (!billing) {
          this.$message.warning(self.$t('common.tips.hasOneOnly'))
          return
        }
        if (!isView && this.hasAgentBilling()) {
          this.$message.warning(self.$t('CargoMsg.Cargo_AgentBillingCanNotEdit'))
          return
        }
        if (!isView && !!billing.approvalStatus && billing.approvalStatus !== BPM_STATES_UN_APPROVED.code) {
          this.$message.warning(self.$t('CargoMsg.Cargo_EditUnApprovedBillTips'))
          return
        }
        if (!isView && !BillingUtils.editable(billing)) {
          return
        }
        self.billingUuid = billing.uuid
      } else {
        self.billingUuid = billing.uuid
      }
      self.currentOptStatus = this.optStatusDefs.billDetailView
    },
    // 点击行 校验按钮是否显示
    onBillingGridItemClick(billing) {
      this.selectedBilling = null
      if (billing) {
        this.selectedBilling = billing
      }
      this.btnEnableBtnInvalid = (this.selectedBilling && (this.selectedBilling.state === 2) && !this.selectedBilling.billingGroupUuid && this.selectedBilling.realClearingState === ClearingConstants.CLEARING_STATE_NON.code)
    },
    // 删除账单
    async deleteBilling() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('act.billing.pleaseSelectBilling'))
        return
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }

      let advanceBillWithPushedStatus = false // 是否有推送过的代收代付
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) { // 针对于国外账单， 只有当账单状态为 未打印、已打印、的要可以编辑、删除
          if (![BillingConstants.BILLING_NOT_PRINTED.code,
            BillingConstants.BILLING_INVOICED.code, BillingConstants.BILLING_NORMAL.code].includes(billing.state) || billing.confirmed) {
            if (billing.billingNo) {
              this.$message.warning(this.$t('act.billing.hasConfirmed', [billing.billingNo]))
            } else {
              this.$message.warning(this.$t('CargoMsg.Cargo_BillConfirmed'))
            }
            return false
          }
          if (billing.syncExternalStatus === 1 && !billing.advance) {
            this.$message.warning(this.$t('act.billing.overseaHasPushed', [billing.billingNo]))
            return false
          }
        } else {
          if (billing.state > Number(BillingConstants.BILLING_NORMAL.code)) {
            this.$message.warning(this.$t('act.billing.hasConfirmed', [billing.billingNo]))
            return
          }
        }
        if (billing.advance && billing.syncExternalStatus === 1) {
          advanceBillWithPushedStatus = true
        }
        if (billing.billingGroupUuid) {
          this.$message.warning(this.$t('act.billing.hasBillingGroup', [billing.billingNo]))
          return
        }
        if (billing.invoiceState > 0) {
          this.$message.warning(this.$t('act.billing.hasInvoice', [billing.billingNo]))
          return
        }
        if (billing.realClearingState > 0) {
          this.$message.warning(this.$t('act.billing.hasWriteOff', [billing.billingNo]))
          return
        }
        if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code && (billing.state > BillingConstants.BILLING_NORMAL.code || billing.billingNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteBillTips'))
          return
        }
        // CARGO-24939，接收付款信息进行账单锁定
        if (billing.ocPaymentLock !== undefined && billing.ocPaymentLock) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteOCBillTips'))
          return
        }
        if (billing.review === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteRecheckedBillTips'))
          return
        }
        if (!!billing.approvalStatus && billing.approvalStatus !== BPM_STATES_UN_APPROVED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteUnApprovedBillTips'))
          return
        }
      }

      try {
        if (advanceBillWithPushedStatus) {
          await this.$confirm(this.$t('act.billing.advDeleteConfirmTitle'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          })
        }

        await this.$confirm(this.$t('act.billing.confirmDelete', [chooseRows.length]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        })
      } catch (error) {
        return
      } finally {
      // 确保 loading 关闭
        if (this.loading) {
          this.loading.close()
        }
      }

      const ids = []
      for (const item of chooseRows) {
        ids.push(item.uuid)
      }
      this.loading = getLoading()
      batchDelBilling(ids, this.location).then(res => {
        this.$message.success(this.$t('common.tips.deleteSuccess'))
        this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 确认账单
    async confirmBilling(customInstructionUuid = null) {
      this.customInstructionUuid = customInstructionUuid
      const chooseRows = this.$refs.queryBilling.getSelections()
      this.btnConfimKeys = []
      const bs = Number(cache.config.get('BillingNoteContainInvoiceReques'))
      const uuidList = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        // 国内应收
        if (bs && billing.makeInvoiceType === 0 && billing.ar && billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
          uuidList.push(billing.uuid)
        }
        const state = billing.state
        if ((state === Number(BillingConstants.BILLING_NORMAL.code) || !billing.confirmed) && !billing.billingGroupUuid) {
          this.btnConfimKeys.push({ 'key': billing.uuid, 'version': billing.version })
        }
      }
      if (uuidList && uuidList.length > 0) {
        const res = await checkConfirmBilling(uuidList)
        if (res && res.data && res.data.length > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_RemarkTip2'))
          return
        }
      }
      if (this.btnConfimKeys.length === 0) {
        this.$message.warning(this.$t('act.billing.noConfirmBill'))
        return
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      this.$confirm(this.$t('act.billing.batchConfirmBill', [this.btnConfimKeys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        // 执行验证规则校验
        return this.checkRuleAndConfirm(true)
      }).catch(() => {
      })
    },
    batchConfirmHandle() {
      if (this.customInstructionUuid != null && this.customInstructionUuid.length > 0) {
        this.instructionConfirmBilling()
      } else {
        batchConfirmBilling(this.btnConfimKeys, this.location).then(res => {
          this.$message.success(this.$t('act.billing.confirmSuccess'))
          this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
        }).finally(() => {
        })
      }
    },
    // 取消确认账单
    unConfirmBilling() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const keys = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        const state = billing.state
        if ((state >= Number(BillingConstants.BILLING_VERIFIED.code) || billing.confirmed) && !billing.billingGroupUuid && billing.review === 0) {
          keys.push({ 'key': billing.uuid, 'version': billing.version })
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
        return
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      this.tabBillingHp.unConfirmBilling(keys)
    },
    // 复核账单
    recheckBilling() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const billing = this.selectedBilling
      let billings = []
      if (chooseRows && chooseRows.length !== 0) {
        billings = [...chooseRows]
      } else if (billing) {
        billings.push(billing)
      }
      if (billings.length === 0) {
        this.$message.warning(this.$t('act.billing.noRecheckBill'))
        return
      }
      this.btnRecheckBillings = []
      for (let i = 0; i < billings.length; i++) {
        const billing = billings[i]
        const state = billing.state
        if ((state === Number(BillingConstants.BILLING_VERIFIED.code) || billing.confirmed) && billing.review === 0) {
          this.btnRecheckBillings.push({ 'uuid': billing.uuid, 'version': billing.version })
        }
      }
      if (this.btnRecheckBillings.length === 0) {
        this.$message.warning(this.$t('act.billing.noRecheckBill'))
        return
      }
      this.$confirm(this.$t('act.billing.batchRecheckBill', [this.btnRecheckBillings.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        // 执行验证规则
        return this.checkRuleAndConfirm(false)
      }).catch(() => {
      })
    },
    btachRecheckHandle() {
      recheckBilling(this.btnRecheckBillings).then(res => {
        this.$message.success(this.$t('act.billing.recheckSuccess'))
        this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
      }).finally(() => {
        this.selectedBilling = null
      })
    },
    // 取消复核账单
    cancelRecheckBilling() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const billing = this.selectedBilling
      let billings = []
      if (chooseRows && chooseRows.length !== 0) {
        billings = [...chooseRows]
      } else if (billing) {
        billings.push(billing)
      }
      if (billings.length === 0) {
        this.$message.warning(this.$t('act.billing.noCancelRecheckBill'))
        return
      }
      for (const billing of billings) {
        if (this.toExoSystemTp && billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code && billing.billingNo && billing.billingNo.trim().length > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillGeneratedNoCancel'))
          return
        }
      }
      const keys = []
      for (let i = 0; i < billings.length; i++) {
        const billing = billings[i]
        if (billing.review === 1) {
          keys.push({ 'uuid': billing.uuid, 'version': billing.version })
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billing.noCancelRecheckBill'))
        return
      }
      this.$confirm(this.$t('act.billing.cancelRecheckBill', [keys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        return cancelRecheckBilling(keys).then(res => {
          this.$message.success(this.$t('act.billing.cancelRecheckSuccess'))
          this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
        }).finally(() => {
          this.selectedBilling = null
        })
      }).catch(() => {
      })
    },
    // 打印账单
    printBilling(command) {
      const billings = this.$refs.queryBilling.getSelections()
      if (billings.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      // if (this.hasOverseasBillVarifyBillStatus()) {
      //   this.$message.warning(this.$t('CargoMsg.Cargo_ForeignBillStatusError'))
      //   return
      // }
      if (!BillingUtils.hasOverseasBillVarifyBillStatus(billings)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ForeignBillStatusError'))
        return
      }
      const keyList = []
      const billingNos = []
      const jobNos = []
      for (const billing of billings) {
        if (billing.uuid && keyList.indexOf(billing.uuid) < 0) {
          keyList.push(billing.uuid)
          billingNos.push(billing.billingNo)
          jobNos.push(billing.jobUuid ? billing.jobNo : '')
        }
      }
      const multiplePrint = keyList.length > 1 && command === this.$t('Clearing.PrintByAccountNumber') // 是否按照多个打印
      const params = {}
      params.BILLING_UUID_LIST = keyList
      params.BILLING_UUID = params.BILLING_UUID_LIST
      params.printSource = DocumentConstants.BATCH_PRINT_ZD.code
      if (billings[0].billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
        if (billings.length === 1) {
          params.billingNo = billings[0].billingNo
          if (billings[0].jobUuid) {
            params.jobNo = billings[0].jobNo
          }
        }
        if (multiplePrint) {
          Object.assign(params, {
            BILLING_UUID_LIST: keyList[0],
            BILLING_UUID: keyList[0],
            multiplePrint: true,
            multipleBillingUuid: keyList,
            multipleBillingNo: billingNos,
            multipleJobNo: jobNos
          })
        }
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'INTERNALBILLING'
        this.templateSelectorDialog.visible = true
      } else {
        if (multiplePrint) {
          Object.assign(params, {
            BILLING_UUID_LIST: keyList[0],
            BILLING_UUID: keyList[0],
            multiplePrint: true,
            multipleBillingUuid: keyList
          })
        }
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLING'
        this.templateSelectorDialog.visible = true
        this.prePrintCallback = this.prePrint
      }
    },

    /**
     * 打印回调动作
     */
    async prePrint(printEvent) {
      const billings = this.$refs.queryBilling.getSelections()
      let needSet = false
      let billing
      for (billing of billings) {
        if (!billing.billingNo) {
          needSet = true
          break
        }
      }
      if (needSet) {
        const printDate = ColumnUtils.dateTimeLabelFunc(new Date())
        for (billing of billings) {
          if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code && !billing.overseaInvoiceDate) {
            billing.overseaInvoiceDate = printDate
          }
          billing.isPrint = true
        }
        return setBillingsNo(billings).then(() => {
          this.backBillingList()
          return this.doPrint(billing, printEvent)
        })
      } else {
        return this.doPrint(billing, printEvent)
      }
    },

    doPrint(billing, printEvent) {
      if (StimulSoftUtil.isOpenStiReport(printEvent.template)) {
        return this.$refs.cargoTemplateSelectorDialog.printFileV2(printEvent)
      } else {
        const printType = printEvent.parameter.printType
        printEvent.parameter.fileAliasName = billing.billingNo
        if (printType === PrintTemplateManager.EMAIL) {
          return this.$refs.cargoTemplateSelectorDialog.sendEmailTriggerEventHandler(printEvent)
        } else if (printType === PrintTemplateManager.FAX) {
          return PrintTemplateManager.fax(printEvent.template, PrintTemplateManager.FORMAT_PDF, printEvent.parameter)
        } else {
          return PrintTemplateManager.print(printEvent.template, printEvent.documentType, printEvent.format, printEvent.parameter, printEvent.action === 'print')
        }
      }
    },
    // 创建对账单
    async createBillingGroupClick() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('act.billing.pleaseSelectBilling'))
        return
      }
      let settlementAgentId = -1
      let passThrough = true
      // 对账单关联的账单集合
      const billings = []
      // 银行数组
      const bankArray = []
      // 币种数组
      const currencyArray = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        if (!billing.billingGroupUuid) {
          if (settlementAgentId === -1 || billing.settlementAgentId === settlementAgentId) {
            settlementAgentId = billing.settlementAgentId
            const bankAccountId = billing.bankAccountId
            const currency = billing.currency
            billings.push(billing)
            if (bankAccountId && bankArray.indexOf(bankAccountId) < 0) {
              bankArray.push(bankAccountId)
            }
            if (currency && currencyArray.indexOf(currency) < 0) {
              currencyArray.push(currency)
            }
          } else {
            this.$message.warning(this.$t('act.billing.sameSettlementAgent'))
            passThrough = true
            return
          }
        } else {
          if (billing.billingGroupBillingNo) {
            this.$message.warning(this.$t('act.billing.hasBillingGroup', [billing.billingNo]))
            passThrough = true
            return
          }
        }
        const check = await BillingUtils.checkBillingState(this, billing)
        if (!check) {
          const value = billing.review ? 0 : 1 // 显示相反的
          this.$message.warning(this.$t('CargoMsg.Cargo_checkBillingGroup', [billing.billingNo, ColumnUtils.billingReviewLabelFunc(value)]))
          passThrough = true
          return
        }
      }
      if (!passThrough) {
        return
      }
      if (billings.length === 0) {
        this.$message.warning(this.$t('act.billing.noBillToBillingGroup'))
        return
      }
      // 对账单详情-账单列表数据源
      const newBillings = BillingUtils.entryConvertToObject(billings)
      const billingGroup = new BillingGroup().fillDefaultValue().getData()
      billingGroup.makeBillingGroupPaymentReceiveMethod = this.searchConditions.paymentType
      const newBillingGroup = await BillingUtils.createBillingGroup(billingGroup, newBillings)
      newBillingGroup.hasAgentBilling = this.hasAgentBilling()
      let title = ''
      let isSame = true
      for (const billing of chooseRows) {
        // 忽略开票抬头为空的数据
        if (StrUtils.isEmpty(billing.title)) {
          continue
        }
        if (StrUtils.isEmpty(title)) {
          title = billing.title
          continue
        }
        if (title !== billing.title) {
          isSame = false
          break
        }
      }
      if (!isSame) {
        let checkTitle = false
        await this.$confirm(this.$t('Message.TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          newBillingGroup.title = chooseRows[0]['title']
        }).catch(() => {
          checkTitle = true
        })
        if (checkTitle) {
          return
        }
      }
      if (newBillingGroup && !newBillingGroup.accountId) {
        this.$message.warning(this.$t('Clearing.SettlementTheBillCannotEmpty'))
        return
      }
      const checkInvoiceTitle = await BillingUtils.checkBillingIsSameInvoiceTitle(billingGroup, newBillings, this)
      if (checkInvoiceTitle) {
        return
      }
      if (bankArray.length === 1) {
        newBillingGroup.bankAccountId = bankArray[0]
      } else if (currencyArray.length === 1) {
        newBillingGroup.bankAccountId = await this.loadBankAccounts(currencyArray[0])
      } else {
        newBillingGroup.bankAccountId = await this.loadBankAccounts('RMB')
      }
      this.billingGroupProperties.billingGroup = newBillingGroup
      this.billingGroupProperties.billings = newBillings
      // 显示对账单界面
      this.currentOptStatus = this.optStatusDefs.billGroupDetailView
    },
    // 查找默认银行
    async loadBankAccounts(currency) {
      let bankAccountId = 0
      const bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
        return res.data
      })
      if (bankAccounts) {
        for (let i = 0; i < bankAccounts.length; i++) {
          const bankAccount = bankAccounts[i]
          if (bankAccount.currency === currency && (bankAccount.isRmbAccount || bankAccount.isUsdAccount)) {
            bankAccountId = bankAccount.accoundId
            break
          }
        }
      }
      return bankAccountId
    },
    // 创建对账单-点击返回按钮或者账单点击返回按钮
    backBillingList(result) {
      this.currentOptStatus = 'normal'
      if (result) {
        if (result['action'] !== 'cancelSave') { // 创建对账单-点击取消保存动作（cancelSave）
          const rowData = this.$refs.queryBilling.rowData
          const billing = result['data']
          if (billing && rowData && rowData.length > 0) {
            for (const item of rowData) {
              if (item.uuid === billing.uuid) {
                Object.assign(item, billing)
              }
            }
          }
          const tempRowData = rowData
          this.$nextTick(() => {
            this.$refs.queryBilling.rowData = tempRowData
          })
        }
      } else { // 创建对账单-点击保存-保存成功后-点击返回按钮，由于字段不一致，所以需要重新查询列表数据
        this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
      }
    },
    // 开票/收票触发事件
    async makeInvoiceEvent() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('act.billing.pleaseSelectBilling'))
        return false
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      for (const row of chooseRows) {
        if (row.redPunchState > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ReversedBillNoInvoice'))
          return
        }
      }

      // 统一逻辑：只看 invoiceState 是否一致，以及（当全部开票时）invoiceUuid 是否唯一且非空。
      const invoiceStateSet = new Set()
      for (const billing of chooseRows) {
        invoiceStateSet.add(Number(billing.invoiceState))
      }
      const invoiceStates = Array.from(invoiceStateSet)
      if (invoiceStates.length !== 1) {
        this.$message.error('勾选的账单，开票状态不一致')
        return
      }
      const invoiceState = invoiceStates[0]

      // 全部开票：校验 invoiceUuid 一致 -> 打开发票详情
      if (invoiceState === Number(BillingConstants.INVOICE_STATE_FULL.code)) {
        const invoiceUuidSet = new Set()
        for (const billing of chooseRows) {
          const raw = billing ? billing.invoiceUuid : ''
          if (StrUtils.isEmpty(raw)) continue
          String(raw).split(',').map(s => String(s).trim()).filter(s => !StrUtils.isEmpty(s)).forEach(s => invoiceUuidSet.add(s))
        }
        const invoiceUuids = Array.from(invoiceUuidSet)
        if (invoiceUuids.length !== 1) {
          this.$message.error('勾选的账单，对应的发票不一致')
          return
        }
        await this.openInvoiceDetailsByBillings(chooseRows)
        return
      }

      // 未开票/其它：保持现有开票逻辑
      const passThrough = await this.validateBilling2Invoice(chooseRows)
      if (passThrough) {
        await this.startMakeInvoiceByBillings(chooseRows)
      }
    },
    startMakeInvoiceByBillings(chooseRows) {
      this.makeInvoiceProperties.isAr = this.searchConditions.paymentType === 1
      this.makeInvoiceProperties.isHedge = false
      this.makeInvoiceProperties.isSkipInvoiceFrom = false
      // 请求后台，返回开票界面的树状结构数据源以及相关基础属性
      const ids = []
      for (const item of (chooseRows || [])) {
        ids.push(item.uuid)
      }
      this.makeInvoiceProperties.keys = ids
      this.makeInvoiceProperties.step = 'step1'
      this.makeInvoiceProperties.selectedEntities = chooseRows
      return this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    async openInvoiceDetailsByBillings(chooseRows) {
      try {
        const invoiceRef = this.resolveMakeInvoiceDialogRef()

        // 用户要求：不反查费用，只用勾选行的 invoiceUuid 打开发票详情
        const rowInvoiceUuids = new Set()
        for (const b of (chooseRows || [])) {
          if (!b) continue
          const raw = b.invoiceUuid
          if (StrUtils.isEmpty(raw)) continue
          String(raw).split(',').map(s => String(s).trim()).filter(s => !StrUtils.isEmpty(s)).forEach(s => rowInvoiceUuids.add(s))
        }
        const invoiceUuids = Array.from(rowInvoiceUuids)
        if (invoiceUuids.length !== 1) {
          this.$message.error('勾选的账单，对应的发票不一致')
          return
        }
        const openFn = (invoiceRef && typeof invoiceRef.openInvoiceDetails === 'function')
          ? invoiceRef.openInvoiceDetails
          : (invoiceRef && invoiceRef.$options && invoiceRef.$options.methods && typeof invoiceRef.$options.methods.openInvoiceDetails === 'function')
            ? invoiceRef.$options.methods.openInvoiceDetails
            : null
        if (!invoiceRef || !openFn) {
          return
        }
        await openFn.call(invoiceRef, invoiceUuids)
      } catch (e) {
        // 防止接口异常导致“点击无反应”
        this.$message.error('打开发票详情失败')
      }
    },
    resolveMakeInvoiceDialogRef() {
      // Prefer explicit ref. If it isn't available (or isn't a Vue component instance),
      // fall back to searching the child component tree.
      let ref = this.$refs ? this.$refs.invoice : null
      if (Array.isArray(ref)) ref = ref[0]
      if (ref && (typeof ref.openInvoiceDetails === 'function' || (ref.$options && ref.$options.methods && typeof ref.$options.methods.openInvoiceDetails === 'function'))) return ref

      const stack = [...(this.$children || [])]
      while (stack.length > 0) {
        const c = stack.shift()
        if (!c) continue
        if (c.$options && c.$options.name === 'StartMakeInvoice' &&
          (typeof c.openInvoiceDetails === 'function' || (c.$options.methods && typeof c.$options.methods.openInvoiceDetails === 'function'))) {
          return c
        }
        if (c.$children && c.$children.length > 0) stack.push(...c.$children)
      }
      return null
    },
    // 申请付款
    async doBillPayment() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return false
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }
      const isSameAccount = ClearingUtils.isSameAccount(chooseRows)
      const isSameSettlementAgent = isSameAccount ? false : ClearingUtils.isSameSettlementAgent(chooseRows)
      if (!isSameAccount && !isSameSettlementAgent) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyOrSettlementAgentInconsistent'))
        return
      }
      if (!ClearingUtils.createBillPaymentCheckBillingState(chooseRows)) return
      if (!this.paymentApplicationSendingCloudPlatform) {
        const charges = await ClearingUtils.createBillPaymentByBilling(chooseRows, this.searchConditions.paymentType)
        if (charges && charges.length > 0) {
          this.showBillPaymentDialog = true
          const initData = isSameSettlementAgent ? { accountId: chooseRows[0].settlementAgentId, settlementAgentId: chooseRows[0].settlementAgentId } : {}
          this.$refs.billPayment.initBillPayment(charges, initData)
        }
      } else {
        this.billPaymentDialogForH5.defaultConditions.billingKeys = []
        for (const billing of chooseRows) {
          this.billPaymentDialogForH5.defaultConditions.billingKeys.push(billing.uuid)
        }
        this.billPaymentDialogForH5.visible = true
      }
    },
    // 付款申请关闭按钮回调事件
    cancelBillPayment() {
      this.showBillPaymentDialog = false
    },
    // 重新加载列表数据
    reloadData() {
      this.showLoading = false
      this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions, false, true)
    },
    // 校验账单是否符合开票要求
    async validateBilling2Invoice(chooseRows) {
      await cache.load(cacheName.CONFIG)
      const invoiceBillingState = cache.config.get('InvoiceBillingState')
      if (invoiceBillingState) {
        const invoiceBillingStateArray = invoiceBillingState.split(',')
        if (invoiceBillingStateArray) {
          for (let i = 0; i < chooseRows.length; i++) {
            let ok = false
            const billing = chooseRows[i]
            for (const stateStr of invoiceBillingStateArray) {
              const state = parseInt(stateStr)
              if (state === 12 && billing.review === 1) {
                ok = true
              } else if (state === 13 && billing.review === 0) {
                ok = true
              } else if (state === billing['state'] || (state === BillingConstants.BILLING_NORMAL.code && !billing.confirmed) || (state === BillingConstants.BILLING_VERIFIED.code && billing.confirmed)) {
                ok = true
              }
            }
            if (!ok) {
              this.$message.warning(this.$t('CargoMsg.Cargo_SDNMBR'))
              return false
            }
          }
        }
      }
      // 校验分公司是否符合开票要求
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }

      let ar = false
      let ap = false
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        if (billing.ar) {
          ar = true
        } else {
          ap = true
        }
      }
      // 有应收和应付费用 必须开票收票权限都有
      if (ar && ap && (!this.role.createInvoiceFromBilling || !this.role.createInvoiceApFromBilling)) {
        let d = this.$t('CargoMsg.Cargo_CollectInvoice')
        if (this.role.createInvoiceFromBilling) {
          d = this.$t('CargoMsg.Cargo_Invoicing')
        }
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip2', [d]))
        return
      } else if (ar && !this.role.createInvoiceFromBilling) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_CollectInvoice')]))
        return
      } else if (ap && !this.role.createInvoiceApFromBilling) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoInvoiceTip', [this.$t('CargoMsg.Cargo_Invoicing')]))
        return
      }
      return true
    },
    // 销账
    writeoffHandler() {
      this.properties.selectedEntities = this.$refs.queryBilling.getSelections()
      if (this.properties.selectedEntities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }
      if (!ClearingUtils.isSameAccount(this.properties.selectedEntities)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
        return
      }
      this.properties.writeoffBillingState = String(cache.config.get('WriteoffBillingState'))
      const writeOffBillingState = []
      this.properties.writeoffBillingState.split(',').forEach(function(value) {
        writeOffBillingState.push(Number(value))
      })
      if (writeOffBillingState && this.properties.selectedEntities) {
        for (const billing of this.properties.selectedEntities) {
          let ok = false
          for (const state of writeOffBillingState) {
            // WriteoffBillingState 3-已复核 4-未复核 （CARGO-29704 国内账单、国外账单增加二次审核/确认的功能）
            if (state === 12 && billing.review === 1) {
              ok = true
            } else if (state === 13 && billing.review === 0) {
              ok = true
            } else if (state === billing.state || (state === BillingConstants.BILLING_NORMAL.code && !billing.confirmed) || (state === BillingConstants.BILLING_VERIFIED.code && billing.confirmed)) {
              ok = true
            }
          }
          if (!ok) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SDNMBR'))
            return false
          }
          if (billing.ar && !billing.prePayment && billing.ocCanWriteOff !== undefined && !billing.ocCanWriteOff) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OCCanWriteOff'))
            return
          }
        }
      }
      this.initEntities()
    },
    async initEntities() {
      console.log('initEntities')
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      this.properties.isExt = Number(cache.config.get('ext')) === 1
      this.properties.writeoffByDifferentAccount = Number(cache.config.get('WriteoffByDifferentAccount')) === 1
      this.properties.writeoffCheckBillpaymentDone = Number(cache.config.get('WriteoffCheckBillpaymentDone')) === 1
      this.properties.mustUseActualAmountWriteoff = Number(cache.config.get('MustUseActualAmountWriteoff')) === 1
      this.properties.isHQWriteoffConfirm = Number(cache.config.get('isHQWriteoffConfirm')) === 1
      this.properties.isWriteoffCurrencyByInvoice = Number(cache.config.get('isWriteoffCurrencyByInvoice')) === 1
      this.properties.payAfterPayApply = Number(cache.config.get('PayAfterPayApply'))
      //
      this.properties.selectedEntitiesOrigin = this.properties.selectedEntities
      this.properties.isAr = this.properties.selectedEntities[0].ar
      this.properties.isEntitiesAr = this.properties.isAr
      this.properties.isOversea = false
      // if (this.searchConditions.chargeTypeGroup === 1) this.properties.defaultCurrency = 'USD'
      if (this.properties.selectedEntities[0].billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) this.properties.defaultCurrency = 'USD'
      this.properties.writeOffMode = 3 // 账单
      this.properties.entities = []
      const keys = []
      for (const item of this.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'classType': 'billing', 'isOversea': this.properties.isOversea, 'officeId': this.$store.getters.currentOfficeId }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AllSelectedBillsWrittenOff'))
        return
      }
      this.properties.accountId = this.properties.entities[0].accountId
      // 按账单销账：未核销
      if (this.properties.writeOffMode === 3) {
        const billingUuids = []
        for (const charge of this.properties.entities) {
          if (billingUuids.indexOf(charge.billingUuid) === -1) {
            billingUuids.push(charge.billingUuid)
          }
        }
        const selectedEntitiesNew = []
        for (const item of this.properties.selectedEntities) {
          if (billingUuids.indexOf(item.uuid) !== -1) {
            selectedEntitiesNew.push(item)
          }
        }
        this.properties.selectedEntities = selectedEntitiesNew
      }
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      //
      this.properties.currencys = []
      for (const charge of this.properties.allEntities) {
        if (this.properties.currencys.indexOf(charge.currency) === -1) {
          this.properties.currencys.push(charge.currency)
        }
      }
      //
      if (this.checking()) {
        this.writeOffDialog.visible = true
      }
    },
    checking() {
      if (this.properties.payAfterPayApply === 1 || this.properties.payAfterPayApply === 2 || this.properties.payAfterPayApply === 3) {
        if (this.properties.payAfterPayApply === 2) {
          const allAr = this.checkAllReceivable(this.properties.selectedEntities)
          const writeOffMode = this.properties.isHedge ? this.properties.writeOffModeHedge : this.properties.writeOffMode
          if (allAr && [2, 3, 4].includes(writeOffMode)) {
            return true
          }
        }
        for (const charge of this.properties.entities) {
          if (this.properties.payAfterPayApply === 3) {
            if (!charge.isReceivable && (charge.billPaymentUuid && [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail2'))
              return false
            }
          } else {
            if (!charge.isReceivable && (StrUtils.isEmpty(charge.billPaymentUuid) || [0, 1, 2, 6].includes(charge.billPaymentState))) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail'))
              return false
            }
          }
        }
      }
      return true
    },
    checkAllReceivable(rows) {
      for (const row of rows) {
        if (!row.ar) {
          return false
        }
      }
      return true
    },
    // 作废
    onInvalidClickEvent() {
      const selectedBill = this.$refs.queryBilling.selectedItem
      if (!selectedBill) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      // if (selectedBill.billingType === '国内账单') {
      //   this.$message.warning(this.$t('Message.DomesticBillsCannotBeVoided'))
      //   return
      // }

      if (selectedBill.jobState !== 0) {
        this.$message.warning(this.$t('Message.ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided'))
        return
      }

      if (selectedBill.state === 3) {
        this.$message.warning(this.$t('Message.ThisOrderHasBeenRevokedNotARepeatedAction'))
        return
      }
      if (selectedBill.paymentState > 0) {
        this.$alert(this.$t('queryJob.BillCannotVoid', [selectedBill.billingNo, this.$t('queryJob.ApplicationPayInitiated')]), this.$t('common.tips.prompt'), {
          dangerouslyUseHTMLString: true,
          showClose: false,
          confirmButtonText: this.$t('common.btn.close'),
          type: 'warning'
        })
        return
      }
      if (selectedBill.state === 2 || selectedBill.state === 1) {
        this.$alert(this.$t('Message.TheBillHasBeenConfirmedAndCannotBeVoided'), this.$t('common.tips.prompt'), {
          dangerouslyUseHTMLString: true,
          showClose: false,
          confirmButtonText: this.$t('common.btn.close'),
          type: 'warning'
        })
        return
      }
      if (selectedBill.realClearingState !== 0) {
        this.$message.warning(this.$t('Message.ThisVerificationHasBeenDoneAndCannotBeVoided'))
        return
      }
      if (selectedBill.state > 3) {
        this.$message.warning(this.$t('Message.ThisFormIsLockedAndCannotBeVoided'))
        return
      }
      if (selectedBill.billingGroupUuid !== '') {
        this.$message.warning(this.$t('Message.ThisFormIsLockedAndBillingGroup'))
        return
      }
      if (selectedBill.confirmed) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillVoidTipForState'))
        return
      }
      if (selectedBill.review === 1) {
        this.$message.warning(self.$t('CargoMsg.Cargo_BillVoidTipForReview'))
        return
      }
      this.$confirm(this.$t('Message.ConfirmTheCancellationOfTheBill'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        invalidBilling({ billKeys: selectedBill.uuid, location: this.location }).then(async() => {
          this.$message.success(this.$t('Message.TheBillHasBeenRevoked'))
          this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
        })
      })
    },
    // 是否显示作废按钮
    showInvalid() {
      this.permissionBtnInvalid = this.$checkPermission(['button_ACTBilling_toVoidButton']) && (this.searchConditions.chargeTypeGroup === 0 || this.searchConditions.chargeTypeGroup === 1)
    },
    // 列表双击回调函数
    rowDoubleClicked(billing) {
      const hasViewBillingRole = this.$checkPermission(['button_ACTBilling_viewBilling'])
      if (!hasViewBillingRole) {
        this.$message.warning(this.$t('Message.NoHasViewBillingRole'))
        return
      }
      if (billing.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(billing.branchId)) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      this.showBillDetailView(billing, false, true)
    },
    // 选择费用创建付款申请-H5 下一步回调
    async nextCreateBillPaymentCallback(charges) {
      if (charges && charges.length > 0) {
        // 隐藏创建弹窗
        this.billPaymentDialogForH5.visible = false
        // 展示详情弹窗
        this.billPaymentDialogForH5.billPaymentDetailProperties.visible = true
        this.billPaymentDialogForH5.billPaymentDetailProperties.uuid = ''
        this.billPaymentDialogForH5.billPaymentDetailProperties.title = this.$t('Clearing.CreatePaymentRequestDetailedInformation')
        this.billPaymentDialogForH5.billPaymentDetailProperties.state = -1
        this.billPaymentDialogForH5.billPaymentDetailProperties.charges = charges
        this.billPaymentDialogForH5.billPaymentDetailProperties.chargesDirty = true
        this.billPaymentDialogForH5.billPaymentDetailProperties.billPaymentDirty = true
      }
    },
    // 创建付款申请-H5第二步回退至第一步
    toPreStep() {
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = false
      this.billPaymentDialogForH5.visible = true
    },
    // 刷新界面
    refreshBillPaymentH5(billPayment) {
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = false
      this.billPaymentDialogForH5.billPaymentDetailProperties.uuid = billPayment ? billPayment.uuid : ''
      this.billPaymentDialogForH5.billPaymentDetailProperties.visible = true
      this.billPaymentDialogForH5.billPaymentDetailProperties.state = billPayment ? billPayment.state : -1
      this.billPaymentDialogForH5.billPaymentDetailProperties.inputBy = billPayment ? billPayment.inputBy : 0
      this.billPaymentDialogForH5.billPaymentDetailProperties.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
      this.$refs.billPaymentDetailForH5.reloadData()
    },
    // 标记
    signEvent() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const billingKeys = []
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      for (const billing of chooseRows) {
        if (!billing.mark) {
          if (billing.uuid && billingKeys.indexOf(billing.uuid) < 0) {
            billingKeys.push(billing.uuid)
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_MBEIRPSUB'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBillToMark'))
        return
      }
      this.signBillingDialog.billingKeys = billingKeys
      this.signBillingDialog.visible = true
    },
    // 取消标记
    cancelSignEvent() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const billingKeys = []
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      for (const billing of chooseRows) {
        if (billing.mark) {
          if (billing.uuid && billingKeys.indexOf(billing.uuid) < 0) {
            billingKeys.push(billing.uuid)
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_UBEIRPSMB'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBillToMark'))
        return
      }
      cancelSignBilling(billingKeys).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_MarkCancelledSuccessfully'))
        this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
      }).finally(() => {
      })
    },
    signBillingCallBack() {
      this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
    },
    // 强制删除
    async forceDeleteHandler() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      if (chooseRows && chooseRows.length > 0) {
        const keys = []
        for (const billing of chooseRows) {
          keys.push(billing.uuid)
          if ((billing.state !== BillingConstants.BILLING_NOT_PRINTED.code || billing.state !== BillingConstants.BILLING_NORMAL.code) && billing.state === BillingConstants.BILLING_VERIFIED.code &&
            billing.state === BillingConstants.BILLING_INVOICED.code && billing.state === BillingConstants.BILLING_INVALID.code) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ForceDeleteBillTips'))
            return
          }
        }
        const validate = await this.validateForceDeleteBilling(keys)
        if (validate) {
          this.$confirm(this.$t('act.billing.confirmDelete', [chooseRows.length]), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            this.loading = getLoading()
            forceDeleteBilling(keys, this.location).then(res => {
              this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
              this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
            }).finally(() => {
              this.loading.close()
            })
          }).catch(() => {
          })
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
    },
    async validateForceDeleteBilling(keys = []) {
      this.loading = getLoading()
      const data = await validateForceDeleteBilling(keys).then(res => { return res.data }).finally(() => { this.loading.close() })
      if (data.billingNo) {
        let msg = ''
        if (data.hasInvoice) {
          if (msg) {
            msg = msg + this.$t('CargoMsg.Cargo_Invoiced')
          } else {
            msg = this.$t('CargoMsg.Cargo_Invoiced')
          }
        }
        if (data.hasBillPayment) {
          if (msg) {
            msg = msg + '/' + this.$t('Billing.HasBillPayment')
          } else {
            msg = this.$t('Billing.HasBillPayment')
          }
        }
        if (data.hasBillingGroup) {
          if (msg) {
            msg = msg + '/' + this.$t('Billing.HasBillingGroup')
          } else {
            msg = this.$t('Billing.HasBillingGroup')
          }
        }
        if (data.hasWriteOff) {
          if (msg) {
            msg = msg + '/' + this.$t('Billing.HasWriteOff')
          } else {
            msg = this.$t('Billing.HasWriteOff')
          }
        }
        if (data.hasClosingAccount) {
          if (msg) {
            msg = msg + '/' + this.$t('Billing.HasClosingAccount')
          } else {
            msg = this.$t('Billing.HasClosingAccount')
          }
        }
        this.$message.warning(this.$t('Billing.ForceDeleteBilling', [data.billingNo, msg]))
        return false
      }
      return true
    },
    // 校验是否包含代理分成账单
    hasAgentBilling() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      let hasAgentBilling = false
      if (chooseRows && chooseRows.length > 0) {
        for (const billing of chooseRows) {
          if (billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
            hasAgentBilling = true
            break
          }
        }
      }
      return hasAgentBilling
    },
    // 校验国外账单打印状态
    hasOverseasBillVarifyBillStatus() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      let hasOverseasBillVarify = false
      if (chooseRows && chooseRows.length > 0) {
        for (const billing of chooseRows) {
          if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code && this.overseasBillVarifyBillStatus !== -2 && billing.state !== this.overseasBillVarifyBillStatus) {
            hasOverseasBillVarify = true
            break
          }
        }
      }
      return hasOverseasBillVarify
    },
    // 预收标记
    prePaymentHandler() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const billingKeys = []
      for (const billing of chooseRows) {
        if (!billing.prePayment) {
          if (billing.uuid && billingKeys.indexOf(billing.uuid) < 0) {
            billingKeys.push(billing.uuid)
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_MBEIRPSUB'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBillToMark'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmR') + this.$t('CargoMsg.Cargo_OcPrePayment'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        prePayment(billingKeys).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_OcPrePayment') + this.$t('CargoMsg.Cargo_Success'))
          this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    // 取消预收标记
    cancelPrePaymentHandler() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const billingKeys = []
      for (const billing of chooseRows) {
        if (billing.prePayment) {
          if (billing.uuid && billingKeys.indexOf(billing.uuid) < 0) {
            billingKeys.push(billing.uuid)
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_UBEIRPSMB'))
          return
        }
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBillToMark'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmR') + this.$t('CargoMsg.Cargo_OcCancelPrePayment'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        cancelPrePayment(billingKeys).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_OcCancelPrePayment') + this.$t('CargoMsg.Cargo_Success'))
          this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    batchUploadFileHandler() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload'))
        return
      }
      const loading = getLoading4Cxt(this)
      const data = {
        keys: chooseRows.map(row => row.uuid),
        anyStr: 'billing'
      }
      queryJobByChargeKeysFunc(data).then(res => {
        if (!res.data || !res.data.redisKey) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload'))
          return
        }
        if (res.data.multipleLob) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataAndUpload2'))
          return
        }
        this.showCloudFile(res.data)
      }).finally(e => {
        loading.close()
      })
    },
    showCloudFile(data) {
      this.cloudFile.redisKey = data.redisKey
      this.cloudFile.lob = data.lob
      this.cloudFile.num = data.num
      this.cloudFile.visible = true
    },
    // PILL-80 GP率预警加相关校验 该方法为在原本的处理逻辑上添加一层规则校验 该按钮的验证规则节点应该固定只为 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE
    async checkRuleAndConfirm(confirm) {
      const selections = this.$refs.queryBilling.getSelections()
      // 根据选择的数据
      const requestBody = { branchId: this.$store.getters.currentOfficeId }
      requestBody.keys = selections.map(item => item.uuid)
      const chargeList = await getChargeByBillingKeys(requestBody).then(res => res.data)
      // 判断是否开启验证规则
      await cache.load(cacheName.CONFIG)
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        // 查询该分公司配置了是否配置了 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE 节点
        let hasArNode
        let hasApNode
        if (confirm) {
          hasArNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AR_SURE.code, this.$store.getters.currentOfficeId)
          hasApNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AP_SURE.code, this.$store.getters.currentOfficeId)
        } else {
          hasArNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AR_RECHECK.code, this.$store.getters.currentOfficeId)
          hasApNode = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_AP_RECHECK.code, this.$store.getters.currentOfficeId)
        }
        // 判断是否全部为应收
        const allAr = chargeList.every(item => item.chargeReceivable === true)
        // 判断是否全部为应付
        const allAp = chargeList.every(item => item.chargeReceivable === false)
        //  说明该分公司配置了 CheckRuleConstants.NODE_AR_SURE 或者 CheckRuleConstants.NODE_AP_SURE 节点 那么用户勾选的数据就只能全部为AR或者AP
        if ((hasArNode || hasApNode) && !(allAr || allAp)) {
          this.$message.warning(this.$t('CargoMsg.CheckArApDisparity'))
        } else {
          // 开启了验证规则 就判断当前所选的数据是否全部为应收或者全部为应付
          if (this.nodeArApHandle(hasArNode, hasApNode, allAr, allAp)) {
            // 定义回调方法
            let callBack = null
            if (confirm) {
              callBack = this.batchConfirmHandle || null
            } else {
              callBack = this.btachRecheckHandle || null
            }
            // 定义节点
            this.batchCheckingWindow.checkNode = allAr ? confirm ? CheckRuleConstants.NODE_AR_SURE.code : CheckRuleConstants.NODE_AR_RECHECK.code : confirm ? CheckRuleConstants.NODE_AP_SURE.code : CheckRuleConstants.NODE_AP_RECHECK.code
            const jobUuids = chargeList.map(item => item.jobUuid)
            // 根据选择的数据统合billingUuid 然后查询对应的数据
            const jobList = await getJobByKeys(jobUuids).then(res => res.data)
            this.batchCheckingWindow.jobs = jobList
            this.batchCheckingWindow.callBack = callBack
            this.batchCheckingWindow.lob = selections[0].lob
            this.batchCheckingWindow.visible = true
          } else {
            // 分公司开启了验证规则配置, 但是未配置该验证节点 或者验证节点不扽 继续走原本逻辑
            if (confirm) {
              this.batchConfirmHandle()
            } else {
              this.btachRecheckHandle()
            }
          }
        }
      } else {
        // 未开启验证规则就走原本的处理逻辑
        if (confirm) {
          this.batchConfirmHandle()
        } else {
          this.btachRecheckHandle()
        }
      }
    },
    nodeArApHandle(arNode, apNode, allAr, allAp) {
      const result = false
      if (arNode && allAr) {
        return true
      }
      if (apNode && allAp) {
        return true
      }
      return result
    },
    // 红冲账单
    async redPunchBillingHandler() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      const billingKeys = []
      for (const row of chooseRows) {
        if (!(row.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code && row.billingNo && row.billingNo.trim().length > 0)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OverseasBillReverseRule1'))
          return
        }
        if (row.revoked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VoidStatusReverseRule'))
          return
        }
        if (row.redPunchState > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AlreadyReversedRule'))
          return
        }
        billingKeys.push(row.uuid)
      }
      if (billingKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoBillToReverse'))
        return
      }
      // 校验是否开票、核销、付款申请、对账单
      if (await this.validateRedPunchBillingHandler(billingKeys)) {
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmReverseBills', [billingKeys.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const param = {
          billingKeys: billingKeys,
          branchId: this.$store.getters.currentOfficeId
        }
        redPunchBilling(param).then(res => {
          this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    async validateRedPunchBillingHandler(billingKeys) {
      const result = await validateRedPunchBilling(billingKeys).then(res => res.data)
      if (result.billingNo) {
        if (result.hasInvoice) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillInvoicedNoReverse'))
          return true
        }
        if (result.hasBillPayment) {
          this.$message.warning(this.$t('Billing.Cargo_BillPaymentAppliedNoReverse'))
          return true
        }
        if (result.hasBillingGroup) {
          this.$message.warning(this.$t('Billing.Cargo_BillStatementMadeNoReverse'))
          return true
        }
        if (result.hasWriteOff) {
          this.$message.warning(this.$t('Billing.Cargo_BillWrittenOffNoReverse'))
          return true
        }
      }
      return false
    },
    // 导出Accpac海外账单数据
    exportPillBillingHandler() {
      const rows = this.$refs.queryBilling.getSelections()
      // if (rows.length === 0) {
      //   this.$message.warning(this.$t('common.tips.hasOneAtleast'))
      //   return
      // }
      const billingUuids = []
      for (const item of rows) {
        if (item.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) {
          if (StrUtils.isEmpty(item.billingNo)) {
            this.$message.warning(this.$t('PillReport.SelectDataWithBillingNumber'))
            return
          }
          billingUuids.push(item.uuid)
        }
      }
      if (billingUuids.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_InternationalBill'))
        return
      }
      this.loading = getLoading()
      // PILL-1051，CL分公司ACCPAC凭证
      const exportFunc = this.$store.getters.currentOffice.code === 'CL' ? exportBillingCL : exportBilling
      exportFunc({ 'requires': billingUuids }).then(res => {
        if (res.ok) {
          const h = this.$createElement
          this.$msgbox({
            title: this.$t('common.tips.prompt'),
            message: h('p', null, [
              h('p', { style: 'font-size: 18px;padding-bottom:5px' }, this.$t('PillReport.ExportingData')),
              h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
            ]),
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'success'
          })
        } else {
          this.$confirm(res.message, this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            canCloseModule: true,
            type: 'warning'
          })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    syncCloudPlatformFunc() {
      const rows = this.$refs.queryBilling.getSelections()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckNeedSynccloud'))
        return
      }
      const loading = getLoading4Cxt(this)
      syncCloudPlatformQL(rows).then((res) => {
        loading.close()
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
      }).catch(() => {

      }).finally(() => {
        loading.close()
        this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
      })
    },
    showInvoicePoolDialog() {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      this.invoicePoolDialog.sellerTaxNameDefaultValue = chooseRows[0].title
      this.invoicePoolDialog.selectedEntities = chooseRows
      this.invoicePoolDialog.operation = 'collection'
      this.invoicePoolDialog.source = 'billing'
      this.invoicePoolDialog.makeInvoiceMethod = 3
      this.invoicePoolDialog.visible = true
    },
    // 加载指令按钮
    async loadInstructionButtons() {
      const res = await getInstructions({
        pageType: UICustomConstants.BILLING_NATIVE_BILL,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet: true
      })
      this.instructioinBtns = res.data
    },
    async onInstructionClick(item) {
      const chooseRows = this.$refs.queryBilling.getSelections()
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      console.log('item.platformInstructionRuleCode', item)
      if (item.instructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CONFIRMED_BILL.code) {
        // 走账单确认逻辑
        await this.confirmBilling(item.customInstructionUuid)
      } else if (item.instructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CANCEL_CONFIRMED_BILL.code) {
        // 走取消账单逻辑
        await this.instructionUnConfirmBilling(item)
      }
    },
    async instructionConfirmBilling() {
      if (this.btnConfimKeys.length === 0 && !this.customInstructionUuid) {
        return
      }
      const uuids = Array.from(this.btnConfimKeys, p => p.key)
      const params = {
        dataKeys: uuids,
        branchId: this.$store.getters.currentOfficeId,
        userId: this.$store.getters.userId,
        instructionKey: this.customInstructionUuid,
        location: this.location
      }
      this.loading = getLoading()
      await instructionPushInfo(params).then(async res => {
        if (res.data) {
          const result = res.data
          // 接口返回的提示信息
          if (result.errorMsg && result.errorMsg.length > 0) {
            this.$message.error(result.errorMsg)
          } else {
            if (result.successKeys && result.successKeys.length > 0) {
              const confirmKeys = this.btnConfimKeys.filter(item => result.successKeys.includes(item.key))
              if (confirmKeys && confirmKeys.length > 0) {
                await batchConfirmBilling(confirmKeys, this.location).then(res => {
                  this.$message.success(this.$t('act.billing.confirmSuccess'))
                  this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
                })
              }
            } else {
              this.$message.error(result.resultMsg)
            }
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    async instructionUnConfirmBilling(instruction) {
      const chooseRows = this.$refs.queryBilling.getSelections()
      const keys = []
      const uuids = []
      for (let i = 0; i < chooseRows.length; i++) {
        const billing = chooseRows[i]
        const state = billing.state
        if ((state >= Number(BillingConstants.BILLING_VERIFIED.code) || billing.confirmed) && !billing.billingGroupUuid && billing.review === 0) {
          keys.push({ 'key': billing.uuid, 'version': billing.version })
          uuids.push(billing.uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('act.billing.noCancelConfirmBill'))
        return
      }
      if (this.hasAgentBilling()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasAgentBilling'))
        return
      }
      const isSyncCharge = await this.$confirm(this.$t('Message.CancelConfirmBill'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning',
        distinguishCancelAndClose: true
      }).then(() => true).catch(() => false)
      // 调用取消确认账单接口
      const params = {
        dataKeys: uuids,
        branchId: this.$store.getters.currentOfficeId,
        userId: this.$store.getters.userId,
        instructionKey: instruction.customInstructionUuid,
        location: this.location
      }
      this.loading = getLoading()
      await instructionPushInfo(params).then(res => {
        const result = res.data
        if (result) {
          // 系统返回的错误提示信息
          if (result.errorMsg && result.errorMsg.length > 0) {
            this.$message.error(result.errorMsg)
          } else {
            // 接口提示
            const msg = result.resultMsg
            // 成功则调用取消财务审核接口
            if (result.successKeys && result.successKeys.length > 0) {
              const billingKeys = keys.filter(p => result.successKeys.includes(p.key))
              batchUnConfirmBilling(billingKeys, isSyncCharge, this.location).then(res => {
                this.$message.success(msg)
                this.$refs.queryBilling.toAdvQueryList(this.$refs.queryBilling.searchConditions.snapshotConditions)
              })
            } else {
              this.$message.warning(msg)
            }
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
#footer-wrapper-tab-billing {
  align-items: center;
  .fixedBottom {
    position: fixed;
    bottom: 0;
    right: 15px;
    background: #fff;
  }
}
.extension-conditions-form {
  .el-col {
    margin-top: 0!important;
  }
}
</style>
